import styled from 'styled-components';

export const MainBtn = styled.button`
    position: relative;
    display: inline-block;
    padding: 8px 32px;
    background: radial-gradient(50% 50% at 50% 50%, rgba(225, 128, 247, 0) 0%, rgba(127, 88, 183, 0.28) 100%);
    border: none;
    border-radius: 33px;
    color: ${(props) => props.theme.textColor};
    font-family: ${(props) => props.theme.regularFont};
    font-size: 20px;
    font-weight: 400;
    line-height: 36px;
    text-align: center;
    overflow: hidden;
    cursor: pointer;

    &:hover {
        background: linear-gradient(90.72deg, #C65DC6 0.13%, #E180F7 29.49%, #7F58B7 74.55%, #5DBAF2 111.75%, #F7B292 161.72%);
    }

    &::before {
        content: "";
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        border-radius: 33px;
        padding: 2px;
        background: linear-gradient(90.54deg, #C65DC6 0.1%, #E180F7 18.65%, #7F58B7 47.13%, #5DBAF2 70.64%, #F7B292 102.21%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, 
            linear-gradient(#fff 0 0);
        mask-composite: exclude;

    }
`;

export const CircleArrow = styled.button`
    background-color: ${props => props.$colormode === "regular" ? "white" : "#4B2846"};
    border-radius: 50%;
    border: none;
    width: 75px;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    & >svg > path {
        stroke: ${props => props.$colormode === "regular" ? "#4B2846" : "white"};
    }
`;